import React from 'react';
import { useTranslation } from 'react-i18next';
import './EmpowermentBanner.css';

/**
 * EmpowermentBanner - Full-width image with text overlay
 *
 * Features:
 * - Full-width image with proper aspect ratio
 * - Text overlay with gradient for readability
 * - Uses team-collaboration-meeting.png showing diverse women working together
 * - Empowering message
 */
export function EmpowermentBanner() {
  const { t } = useTranslation();

  return (
    <section className="empowerment-banner">
      <div className="empowerment-image-container">
        <img
          src="/story_images/KNOWLEDGE IS POWER PIC.png"
          alt={t('empowermentBanner.imageAlt')}
          className="empowerment-image"
          draggable="false"
        />
        <div className="empowerment-overlay"></div>
        <div className="empowerment-text-content">
          <h2 className="empowerment-heading">{t('empowermentBanner.heading')}</h2>
          <p className="empowerment-subheading">
            {t('empowermentBanner.description')}
          </p>
        </div>
      </div>
    </section>
  );
}
